// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetSiHaDocumentationsRequestModel from '../../model/get-si-ha-documentations-request-model';
import CreateSiHaDocumentationRequestModel from '../../model/create-si-ha-documentation-request-model';
import GetSiHaDocumentationRequestModel from '../../model/get-si-ha-documentation-request-model';
import UpdateSiHaDocumentationRequestModel from '../../model/update-si-ha-documentation-request-model';
import DeleteSiHaDocumentationRequestModel from '../../model/delete-si-ha-documentation-request-model';
import GetSiHaDocumentationByShareIdRequestModel from '../../model/get-si-ha-documentation-by-share-id-request-model';
import ShareSiHaDocumentationRequestModel from '../../model/share-si-ha-documentation-request-model';
import GetSiHaDocumentationSafetyHookListRequestModel from '../../model/get-si-ha-documentation-safety-hook-list-request-model';
import GetSafetyAnchorPointsBySiHaDocumentationRequestModel from '../../model/get-safety-anchor-points-by-si-ha-documentation-request-model';
import DownloadSiHaDocumentationRequestModel from '../../model/download-si-ha-documentation-request-model';
import SiHaDocumentationListPagingResultModel from '../../model/si-ha-documentation-list-paging-result-model';
import SiHaDocumentationModel from '../../model/si-ha-documentation-model';
import SafetyHookListResultModel from '../../model/safety-hook-list-result-model';
import SafetyAnchorPointListListResultModel from '../../model/safety-anchor-point-list-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getSiHaDocumentations(request: GetSiHaDocumentationsRequestModel, config?: RequestConfig) {
    const requestDTO = GetSiHaDocumentationsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-si-ha-documentations'] ?? 'siha/SiHaDocumentation';
    const response = await service.get<any>(endpointPath, {
      query: {
        siHaDocumentationStatusId: requestDTO.siHaDocumentationStatusId,
        dateFrom: requestDTO.dateFrom,
        dateTo: requestDTO.dateTo,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SiHaDocumentationListPagingResultModel.toModel(dto));
  },
  /**  */
  async createSiHaDocumentation(request: CreateSiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = CreateSiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-si-ha-documentation'] ?? 'siha/SiHaDocumentation';
    const response = await service.post<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        shareId: requestDTO.shareId,
        userId: requestDTO.userId,
        siHaDocumentationStatus: requestDTO.siHaDocumentationStatus,
        constructionPlanDocumentExternalId: requestDTO.constructionPlanDocumentExternalId,
        locationMapDocumentExternalId: requestDTO.locationMapDocumentExternalId,
        title: requestDTO.title,
        remark: requestDTO.remark,
        projectNumber: requestDTO.projectNumber,
        clientCompanyName: requestDTO.clientCompanyName,
        clientAddressLine: requestDTO.clientAddressLine,
        clientPostalCode: requestDTO.clientPostalCode,
        clientCity: requestDTO.clientCity,
        clientFirstName: requestDTO.clientFirstName,
        clientLastName: requestDTO.clientLastName,
        clientEMail: requestDTO.clientEMail,
        clientPhoneNumber: requestDTO.clientPhoneNumber,
        addressLine: requestDTO.addressLine,
        city: requestDTO.city,
        postalCode: requestDTO.postalCode,
        nextInspectionDueDate: requestDTO.nextInspectionDueDate,
        safetyHookIds: requestDTO.safetyHookIds,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getSiHaDocumentation(request: GetSiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = GetSiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-si-ha-documentation'] ?? 'siha/SiHaDocumentation/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SiHaDocumentationModel.toModel(dto));
  },
  /**  */
  async updateSiHaDocumentation(request: UpdateSiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = UpdateSiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-si-ha-documentation'] ?? 'siha/SiHaDocumentation/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        shareId: requestDTO.shareId,
        userId: requestDTO.userId,
        siHaDocumentationStatus: requestDTO.siHaDocumentationStatus,
        constructionPlanDocumentExternalId: requestDTO.constructionPlanDocumentExternalId,
        locationMapDocumentExternalId: requestDTO.locationMapDocumentExternalId,
        title: requestDTO.title,
        remark: requestDTO.remark,
        projectNumber: requestDTO.projectNumber,
        clientCompanyName: requestDTO.clientCompanyName,
        clientAddressLine: requestDTO.clientAddressLine,
        clientPostalCode: requestDTO.clientPostalCode,
        clientCity: requestDTO.clientCity,
        clientFirstName: requestDTO.clientFirstName,
        clientLastName: requestDTO.clientLastName,
        clientEMail: requestDTO.clientEMail,
        clientPhoneNumber: requestDTO.clientPhoneNumber,
        addressLine: requestDTO.addressLine,
        city: requestDTO.city,
        postalCode: requestDTO.postalCode,
        nextInspectionDueDate: requestDTO.nextInspectionDueDate,
        safetyHookIds: requestDTO.safetyHookIds,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async deleteSiHaDocumentation(request: DeleteSiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = DeleteSiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-si-ha-documentation'] ?? 'siha/SiHaDocumentation/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
  },
  /**  */
  async getSiHaDocumentationByShareId(request: GetSiHaDocumentationByShareIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetSiHaDocumentationByShareIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-si-ha-documentation-by-share-id'] ?? 'siha/SiHaDocumentation/share/{shareId}';
    endpointPath = endpointPath.replace(/\{shareId\}/g, `${requestDTO.shareId}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SiHaDocumentationModel.toModel(dto));
  },
  /**  */
  async shareSiHaDocumentation(request: ShareSiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = ShareSiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-share-si-ha-documentation'] ?? 'siha/SiHaDocumentation/{id}/Share';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.post<any>(endpointPath, {
      body: {
        sendToEmailAddress: requestDTO.sendToEmailAddress,
        shareLink: requestDTO.shareLink,
      },
      ...config,
    });
  },
  /**  */
  async getSiHaDocumentationSafetyHookList(request: GetSiHaDocumentationSafetyHookListRequestModel, config?: RequestConfig) {
    const requestDTO = GetSiHaDocumentationSafetyHookListRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-si-ha-documentation-safety-hook-list'] ?? 'siha/SiHaDocumentation/{id}/SafetyHooks';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SafetyHookListResultModel.toModel(dto));
  },
  /**  */
  async getSafetyAnchorPointsBySiHaDocumentation(request: GetSafetyAnchorPointsBySiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = GetSafetyAnchorPointsBySiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-safety-anchor-points-by-si-ha-documentation'] ?? 'siha/SiHaDocumentation/{id}/SafetyAnchorPoints';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SafetyAnchorPointListListResultModel.toModel(dto));
  },
  /**  */
  async downloadSiHaDocumentation(request: DownloadSiHaDocumentationRequestModel, config?: RequestConfig) {
    const requestDTO = DownloadSiHaDocumentationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-si-ha-documentation'] ?? 'siha/SiHaDocumentation/{id}/Download';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      responseType: 'blob',
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
});
